import { useState } from "react";

import {
  DIALOG_REMOVED,
  DIALOG_VISIBLE,
  navigationChannel,
} from "../utils/broadcastChannel";
import { isDexibitApi } from "../utils/isDexibitApi";

// Handle dialog showing in iframe
export const useDialogListener = () => {
  const [dialogVisible, setDialogVisible] = useState(false);

  navigationChannel.addEventListener("message", (event: MessageEvent) => {
    if (event.data === DIALOG_VISIBLE) {
      setDialogVisible(true);
    } else if (event.data === DIALOG_REMOVED) {
      setDialogVisible(false);
    }
  });

  // TODO: Remove this once all apps are using broadcast channel
  window.addEventListener("message", (event: MessageEvent) => {
    if (isDexibitApi(event.origin)) {
      const message = event.data;
      if (message === DIALOG_VISIBLE) {
        setDialogVisible(true);
      } else if (message === DIALOG_REMOVED) {
        setDialogVisible(false);
      }
    }
  });

  return { dialogVisible };
};
